import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function formatFileSize(bytes, decimals = 0) {
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let i = 0;
    for (i; bytes > 1024; i++) {
        bytes /= 1024;
    }
    return `${parseFloat(bytes.toFixed(decimals))} ${units[i]}`;
}
